import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {pickingLabelsPrint} from '../../common/util/print';

const INITIAL_STATE = {
  'loading': false,
  'zonesList': [],
  'loadingNextShifts': false,
  'nextShifts': [],
  'loadingIndicators': false,
  'indicators': {},
  'printingLabels': false,
  'pickingLabels': {},
  'loadingLabelsToReprint': false,
  'labelsToBeReprinted': [],
  'printLabelsSuccessfully': false,
};

const updateOrderLabels = (labelsList, {orderCode, labels}, quantityLabelsToCut) => {
  const newLabelsList = {...labelsList};
  newLabelsList[orderCode] = labels;
  if (labels.length > 0) {
    pickingLabelsPrint(labels, quantityLabelsToCut);
  }
  return newLabelsList;
};

const updateLabelsToReprint = (labelsList) => {
  if (labelsList.length > 0) {
    pickingLabelsPrint(labelsList);
  }

  return labelsList;
};

const deleteOrderLabels = (labelsList, orderCode) => {
  const newLabelsList = {...labelsList};
  delete newLabelsList[orderCode];
  
  return newLabelsList;
};

export const pickingDashboard = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_SHIFTS_DATA]: (state, action) => ({
      ...state,
      'printingLabels': false,
      'printLabelsSuccessfully': false,
      'nextShifts': [],
      'indicators': {},
    }),
    [ActionTypes.FETCHING_ZONES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ZONES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'zonesList': action.response.data,
    }),
    [ActionTypes.FETCHED_ZONES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'zonesList': [],
    }),
    [ActionTypes.FETCHING_NEXT_SHIFTS]: (state, action) => ({
      ...state,
      'loadingNextShifts': true,
    }),
    [ActionTypes.FETCHED_NEXT_SHIFTS]: (state, action) => ({
      ...state,
      'loadingNextShifts': false,
      'nextShifts': action.response.data,
    }),
    [ActionTypes.FETCHED_NEXT_SHIFTS_FAILED]: (state, action) => ({
      ...state,
      'loadingNextShifts': false,
    }),
    [ActionTypes.FETCHING_PICKING_INDICATORS]: (state, action) => ({
      ...state,
      'loadingIndicators': true,
    }),
    [ActionTypes.FETCHED_PICKING_INDICATORS]: (state, action) => ({
      ...state,
      'loadingIndicators': false,
      'indicators': action.response.data,
    }),
    [ActionTypes.FETCHED_PICKING_INDICATORS_FAILED]: (state, action) => ({
      ...state,
      'loadingIndicators': false,
      'indicators': {},
    }),
    [ActionTypes.PRINTING_PICKING_LABELS]: (state, action) => ({
      ...state,
      'printingLabels': true,
      'printLabelsSuccessfully': false,
    }),
    [ActionTypes.PRINTED_PICKING_LABELS]: (state, action) => {
      const orderCode = action.payload.orderCode;
      const quantityLabelsToCut = action.payload.quantityLabelsToCut;
      const labels = action.response.data;

      return {
        ...state,
        'printingLabels': false,
        'printLabelsSuccessfully': true,
        'pickingLabels': updateOrderLabels(state.pickingLabels, {orderCode, labels}, quantityLabelsToCut),
      };
    },
    [ActionTypes.PRINTED_PICKING_LABELS_FAILED]: (state, action) => ({
      ...state,
      'printingLabels': false,
      'printLabelsSuccessfully': false,
    }),
    [ActionTypes.DELETE_ALL_PICKING_LABELS]: (state, action) => ({
      ...state,
      'pickingLabels': {},
    }),
    [ActionTypes.DELETE_PICKING_LABELS_BY_ORDER_CODE]: (state, action) => ({
      ...state,
      'pickingLabels': deleteOrderLabels(state.pickingLabels, action.payload),
    }),
    [ActionTypes.GETTING_LABELS_TO_REPRINT]: (state, action) => ({
      ...state,
      'loadingLabelsToReprint': true,
    }),
    [ActionTypes.GOT_LABELS_TO_REPRINT]: (state, action) => ({
      ...state,
      'loadingLabelsToReprint': false,
      'labelsToBeReprinted': updateLabelsToReprint(action.response.data, action.payload),
    }),
    [ActionTypes.GOT_LABELS_TO_REPRINT_FAILED]: (state, action) => ({
      ...state,
      'loadingLabelsToReprint': false,
      'labelsToBeReprinted': [],
    }),
  })(state, action);
};
